import React, { useState, useEffect } from 'react';
import { db, auth } from '../../../firebase';
import { doc, collection, query, where, getDocs, updateDoc, getDoc } from 'firebase/firestore';
import '../member_dashboard/registration_status_page.css';
import { useNavigate } from 'react-router-dom';

const RegistrationStatusPage = () => {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [memberData, setMemberData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Listen for the user session to initialize
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
        if (user) {
        try {

          const userDocRef = doc(db, "registrations", user.uid);
          const userDocSnap = await getDoc(userDocRef);
          
          if (userDocSnap.exists()) {
            const rData = userDocSnap.data();
            // console.log("Member Data Loaded:", rData);
            setMemberData(rData);
          } else {
            console.error("No registration record found for this UID!");
          }
          
            const q = query(
            collection(db, "proposals"),
            where("applicantUid", "==", user.uid)
            );
            
            const snap = await getDocs(q);
            const data = snap.docs.map(d => d.data());
            // console.log("Proposals found for this user:", data.length);
            // console.log("Full Proposal Data:", data);
            setProposals(data);
            
            // Sort or handle data as needed
            setProposals(data);
        } catch (err) {
            console.error("Firestore Error:", err);
        } finally {
            setLoading(false); // Stop loading after data is fetched
        }
        } else {
        // If no user is logged in after checking session
        setLoading(false);
        }
    });

    return () => unsubscribe(); // Cleanup the listener
    }, []);

  const getStepStatus = (step) => {
  // Extract proposals safely using optional chaining instead of an early return block
  const p1 = proposals?.[0];
  const p2 = proposals?.[1];

  switch (step) {
    case 1: 
      return p1?.status === "approved" ? "complete" : "pending";
      
    case 2: 
      return p2?.status === "approved" ? "complete" : "pending";
      
    case 3: 
      return (memberData?.status === "pending_payment" || memberData?.status === "verified") ? "complete" : "pending";
      // const hasPaid = memberData?.status === "pending_admin" || memberData?.status === "verified";
      // return hasPaid ? "complete" : "pending";
      
    case 4: 
      // return memberData?.status === "verified" ? "complete" : "pending";
      const hasPaid = memberData?.status === "verified";
      return hasPaid ? "complete" : "pending";
      
    default: 
      return "pending";
  }
};

  if (loading) return <div className="loader">Checking Status...</div>;

  return (
    <section className="registration-status-section">
    <div className="status-container">
      <h2>Registration Progress</h2>
      <div className="progress-list">
        
        <div className={`step-item ${getStepStatus(1)}`}>
          <div className="step-icon">{getStepStatus(1) === "complete" ? "✓" : "1"}</div>
          <div className="step-details">
            <p className="step-label">Proposer 1 Approval</p>
            <span>{proposals[0]?.proposerName || "Assigned Proposer"}</span>
          </div>
        </div>

        <div className={`step-item ${getStepStatus(2)}`}>
          <div className="step-icon">{getStepStatus(2) === "complete" ? "✓" : "2"}</div>
          <div className="step-details">
            <p className="step-label">Proposer 2 Approval</p>
            <span>{proposals[1]?.proposerName || "Assigned Proposer"}</span>
          </div>
        </div>

        <div className={`step-item ${getStepStatus(3)}`}>
          <div className="step-icon">{getStepStatus(3) === "complete" ? "✓" : "3"}</div>
          <div className="step-details">
            <p className="step-label">Admin Verification</p>
            <span>PArM Secretarial Review</span>
          </div>
        </div>

        {/* <a href={memberData?.status === "pending_payment" ? "/membership-payment-parm" : ''}>
        <div className={`step-item ${getStepStatus(4)}`}>
          <div className="step-icon">{getStepStatus(4) === "complete" ? "✓" : "4"}</div>
          <div className="step-details">
            <p className="step-label">Membership Payment</p>
            <span>{getStepStatus(3) === "complete" ? "Paid" : "Awaiting Payment"}</span>
          </div>
        </div>
        </a> */}

        <div 
          className={`step-item ${getStepStatus(4)} ${memberData?.status === "pending_payment" ? "clickable-step" : ""}`}
          onClick={() => {
            if (memberData?.status === "pending_payment") {
              // navigate("/membership-payment-parm");
            }
          }}
          style={{ 
            cursor: memberData?.status === "pending_payment" ? "pointer" : "default"
          }}
        >
          <div className="step-icon">{getStepStatus(4) === "complete" ? "✓" : "4"}</div>
          <div className="step-details">
            <p 
              className="step-label"
              style={{ 
                // color: memberData?.status === "pending_payment" ? "#2e7d32" : "inherit",
                textDecoration: memberData?.status === "pending_payment" ? "none" : "none",
                fontWeight: memberData?.status === "pending_payment" ? "bold" : "bold"
              }}
            >
              Membership Payment {memberData?.status === "pending_payment"}
            </p>
            <span>{getStepStatus(4) === "complete" ? "Paid" : "Awaiting Payment"}</span>
          </div>
        </div>

      </div>
    </div>
    </section>
  );
};

export default RegistrationStatusPage